<template>  
    <div>        
	    <footer >
	      <p>2018 © ScalperT </p>	      
	    </footer>  	    
	</div>
</template>
<script>   
	export default {    
		data() {
			return {}        
		},
		props: ['registerFooter']
	}
</script>


// WEBPACK FOOTER //
// src/components/prism/shared/footer.vue